module.exports = __webpack_public_path__ + "static/media/noun_click_927323_000000 copy 2.53066e30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/button/toggle_file_modal/assets/noun_click_927323_000000 copy 2.svg
// module id = 275
// module chunks = 0